import { msg } from '@lingui/core/macro';
import { IconSettings } from 'app-ui/icon';

import { type NavigationItem } from '@/navigation/types/NavigationItem';
import { SETTINGS_ROOT_PATH } from '@/settings/constants/SettingsRootPath';

export const SETTINGS_NAVIGATION_ITEM: NavigationItem = {
  id: 'settings',
  label: msg`Settings`,
  Icon: IconSettings,
  path: SETTINGS_ROOT_PATH,
  goToHotkey: 'g s',
};
